import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import './Dashboard.css';
import 'react-rangeslider/lib/index.css';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardSummary } from '../../../redux/MainAction';
import moment from 'moment';
import TaskSummaryChart from './TaskSummaryChart';
import UserCard from '../DashboardCards/UserCard';
import DeadlinesCard from '../DashboardCards/DeadlinesCard';
import TopMembersCard from '../DashboardCards/TopMembersCard';
import WeekActivity from '../DashboardCards/WeekActivity';
import WorkRoles from '../DashboardCards/WorkRoles';
import ProjectsCard from '../DashboardCards/ProjectsCard';
import MemberActivity from '../DashboardCards/MemberActivity';
import AllActivityCard from '../DashboardCards/AllActivityCard';
import YesterDayCard from '../DashboardCards/YesterDayCard';
import ThisWeekCard from '../DashboardCards/ThisWeekCard';
import LastWeekCard from '../DashboardCards/LastWeekCard';
import ImagesCard from '../DashboardCards/ImagesCard';

const Dashboard = () => {
  const dispatch = useDispatch();
  const summ = useSelector((state) => state.Webtracker.dashboardSummary);

  const [currentTime, setCurrentTime] = useState(moment().format('hh:mm A'));

  useEffect(() => {
    dispatch(getDashboardSummary());
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format('hh:mm A'));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const convertSeconds = (seconds) => {
    const isNegative = seconds < 0;
    const duration = moment.duration(Math.abs(seconds), 'seconds');

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();

    const parts = [];
    if (days) parts.push(`${days}d`);
    if (hours || days) parts.push(`${hours}h`);
    parts.push(`${minutes}m`);
    if (!days) parts.push(`${secs}s`);

    return `${isNegative ? '-' : ''}${parts.join(' : ')}`;
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className=" d-flex align-items-center mb-2 ml-2"></div>
        <div className="container-fluid">
          <div
            style={{
              marginLeft: '13px',
              fontSize: '22px',
              color: 'black',
              marginTop: '22px',
              marginBottom: '27px',
            }}
          >
            <h2
              className="col-12 text-capitalize font-600 m-0"
              style={{ letterSpacing: '0.15rem' }}
            >
              Welcome, {localStorage.getItem('firstName')}{' '}
              {localStorage.getItem('lastName')}
            </h2>
          </div>

          <div className="row col-12">
            <AllActivityCard summ={summ} />
            <YesterDayCard summ={summ} convertSeconds={convertSeconds} />
            <ThisWeekCard summ={summ} convertSeconds={convertSeconds} />
            <LastWeekCard summ={summ} convertSeconds={convertSeconds} />
          </div>

          <div className="row col-12">
            <ProjectsCard />
            <MemberActivity />
          </div>

          <div className="row col-12">
            <TopMembersCard />

            <div className="col-6">
              <TaskSummaryChart />
            </div>
          </div>

          <div className="row col-12">
            <WeekActivity />
            <WorkRoles />
          </div>

          <div className="row col-12">
            <ImagesCard />
          </div>

          <div className="row col-12">
            <div className="col-6 ">
              <UserCard />
            </div>
            <div className="col-6">
              <DeadlinesCard />
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default Dashboard;
